// The print order policy shown at /policies/print-orders and agreed to before
// paying for a printed product. Bump PRINT_POLICY_VERSION whenever the text
// changes in substance: the version a buyer agreed to is recorded on their
// Stripe payment (backend/print_orders.py PRINT_POLICY_VERSION must match).
export const PRINT_POLICY_VERSION = '2026-11-03';
export const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL || 'support@memouraa.com';

export const PRINT_POLICY_MARKDOWN = `
This policy applies to printed photo books and calendars ordered through Memouraa, which is operated by The Silver Fern Company Inc. ("we", "us").

## 1. Made to order by our print partners

Every printed product is personalised and made to order. It is printed, packed and shipped by an independent third-party print partner (currently Gelato) and its delivery carriers, not by Memouraa. Production and delivery times shown at checkout are estimates from the print partner and carrier, and are not guaranteed.

## 2. All sales are final

Because each item is made just for you, **all sales are final**. We don't accept returns or give refunds for:

- change of mind, or ordering the wrong product, size, quantity or number of copies;
- content you approved in the preview: the photos you chose, their order, text, captions, dates and layout;
- photos we warned you before payment might print at low resolution, if you chose to print them anyway;
- small, normal variations between how colours look on a screen and on paper.

Please check the preview carefully before you pay.

## 3. Damaged, defective or misprinted items

If your item arrives damaged, has a manufacturing defect, or doesn't match your approved preview because of a printing error, email us at **${SUPPORT_EMAIL}** within **30 days of delivery**. Include your order number and photos of the problem. We'll arrange a free reprint or, if a reprint isn't possible, a refund for the affected item. You don't need to send the item back unless we ask.

## 4. Lost or undelivered orders

If tracking shows your order hasn't arrived within 30 days after its estimated delivery date, contact us. We'll work with the print partner and carrier, and once the parcel is confirmed lost we'll reprint it or refund you. We can't replace orders shipped to an incorrect or incomplete address entered at checkout; a reprint to a corrected address is charged at cost.

## 5. Cancelling an order

You can cancel an order at any time before you pay. After payment, orders go to the print partner quickly; we can cancel only if production hasn't started, and if we do, you get a full refund. Once production has started, an order can't be changed or cancelled.

## 6. Prices, shipping, taxes and duties

Prices are shown in Canadian dollars for Canadian addresses and US dollars elsewhere. Shipping is charged separately at the rate shown at checkout. Any applicable sales taxes are shown at checkout. For shipments outside the country where the item is printed, import duties, taxes or customs fees may be charged on delivery and are the recipient's responsibility.

## 7. Your photos and details

To make and deliver your order, we send the print files and your shipping name and address to our print partner and its carriers, for that purpose only. We keep your order details, including the shipping address, for our accounting records and to help with any issue. By ordering, you confirm you have the right to print the photos and text you include.

## 8. Your legal rights

Nothing in this policy limits any rights you have under the consumer protection laws where you live.

## Contact

Questions about an order: **${SUPPORT_EMAIL}**. Please include your order number.
`;
